import React from "react";
import {
  Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, TablePagination
} from "@mui/material";
import VendedorTableHeader from "./VendedorTableHeader";
import VendedorTableRow from "./VendedorTableRow";

export default function VendedorTable({
  rows,
  loading,
  error,
  ui,
  edgeHitRowId,
  readOnly,
  showVendedorColumn = false,
  vendedores = [],
  selectedAssignmentId,
  onSelectAssignment,
  onEstadoChange,
  estadoDisabled = false,
  onOpenSeguimiento,
  onDropToEstadio,
  onOpenCliente,
  onOpenReassign,
  onReassignVendedor,
  customHeight,
  // Props paginación
  count = 0,
  page = 0,
  rowsPerPage = 20,
  onPageChange,
  onRowsPerPageChange,
}) {
  const isFlexMode = customHeight === "flex";
  const appTable = true;

  return (
    <Box sx={{
      width: "100%",
      overflow: "hidden",
      display: isFlexMode ? 'flex' : 'block',
      flexDirection: 'column',
      flex: isFlexMode ? 1 : 'none',
      minHeight: 0,
      ...(appTable && {
        width: "100%",
        backgroundColor: "rgba(255,255,255,0.96)",
        border: "1px solid #dce5f2",
        borderRadius: "16px",
        boxShadow: "0 20px 44px rgba(19, 39, 84, 0.11)",
        boxSizing: "border-box",
      }),
    }}>
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: appTable ? "12px 12px 8px 8px" : 2,
          border: appTable ? "1px solid #e7edf6" : 0,
          flex: isFlexMode ? 1 : 'none',
          overflowY: 'auto',
          maxHeight: isFlexMode ? 'none' : (readOnly ? "52vh" : "60vh"),
          backgroundColor: "#fff",
        }}
      >
        <Table size="small" aria-label="tabla seguimiento" sx={{ tableLayout: "fixed" }} stickyHeader>
          <TableHead>
            <VendedorTableHeader
              ui={ui}
              showVendedorColumn={showVendedorColumn}
            />
          </TableHead>

          <TableBody>
            {loading && rows.length === 0 && (
              <TableRow><TableCell colSpan={ui.ESTADIOS.length + 2 + (showVendedorColumn ? 1 : 0)} sx={{ py: 4, textAlign: "center" }}><Typography variant="body2">Cargando asignaciones…</Typography></TableCell></TableRow>
            )}
            {!loading && error && (
              <TableRow><TableCell colSpan={ui.ESTADIOS.length + 2 + (showVendedorColumn ? 1 : 0)} sx={{ py: 4, textAlign: "center" }}><Typography variant="body2" color="error">{error}</Typography></TableCell></TableRow>
            )}

            {rows.map((row) => (
              <VendedorTableRow
                key={(row.id_ven_cli ?? row.id)}
                row={row}
                ui={ui}
                edgeHit={edgeHitRowId === (row.id_ven_cli ?? row.id)}
                readOnly={readOnly}
                estadoDisabled={estadoDisabled}
                showVendedorColumn={showVendedorColumn}
                vendedores={vendedores}
                selected={selectedAssignmentId === (row.id_ven_cli ?? row.id)}
                onSelect={() => onSelectAssignment && onSelectAssignment(row)}
                onEstadoChange={(val) => onEstadoChange && onEstadoChange(row, val)}
                onOpenSeguimiento={onOpenSeguimiento}
                onDropToEstadio={onDropToEstadio}
                onOpenCliente={() => onOpenCliente && onOpenCliente(row)}
                onOpenReassign={onOpenReassign}
                onReassignVendedor={onReassignVendedor}
              />
            ))}

            {!loading && !error && rows.length === 0 && (
              <TableRow><TableCell colSpan={ui.ESTADIOS.length + 2 + (showVendedorColumn ? 1 : 0)} sx={{ py: 6 }}><Box sx={{ display: "flex", flexDirection: "Column", alignItems: "center", gap: 1 }}><Typography variant="h6" sx={{ opacity: 0.8 }}>Aún no hay asignaciones</Typography><Typography variant="body2" sx={{ opacity: 0.6 }}>Cuando se carguen clientes aparecerán aqui, ubicados en su estado actual.</Typography></Box></TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box
        sx={{
          flexShrink: 0,
          bgcolor: 'background.paper',
          borderBottomLeftRadius: appTable ? "8px" : 8,
          borderBottomRightRadius: appTable ? "8px" : 8,
          ...(appTable && {
            border: "1px solid #e7edf6",
            borderTop: 0,
          }),
        }}
      >
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      </Box>
    </Box>
  );
}
